import React from 'react';
import { formatAdjustedFeeLabel, isRepeatFeeModule, getRepeatAttemptNumber } from '../../../utils/moduleFeeAdjustment';

const ModuleFeeAdjustmentBadge = ({ module, currency = 'LKR', className = '' }) => {
  const isRepeat = isRepeatFeeModule(module);
  if (!module?.feeAdjusted && !isRepeat) return null;

  const catalog = Number(module.catalogModuleFee) || 0;
  const fee = Number(module.moduleFee) || 0;
  const reason = String(module.feeAdjustmentReason || '').trim();

  if (isRepeat) {
    const attempt = getRepeatAttemptNumber(module);
    const attemptText = attempt ? `Attempt #${attempt}` : null;
    return (
      <div className={`mt-2 rounded-md border border-purple-200 bg-purple-50 px-2.5 py-1.5 text-xs text-purple-950 ${className}`}>
        <div className="flex items-center justify-between gap-2">
          <span className="font-semibold text-purple-900">Repeat Fee</span>
          {attemptText && (
            <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-purple-200 text-purple-800">
              {attemptText}
            </span>
          )}
        </div>
        <p className="mt-0.5">
          {catalog > 0 && catalog !== fee && (
            <span className="line-through text-purple-600/70 mr-1.5">
              {currency} {catalog.toLocaleString()}
            </span>
          )}
          <span className="font-bold text-purple-950">
            {currency} {fee.toLocaleString()}
          </span>
        </p>
      </div>
    );
  }

  return (
    <div className={`mt-2 rounded-md border border-amber-200 bg-amber-50 px-2.5 py-2 text-xs text-amber-900 ${className}`}>
      <p className="font-semibold">Adjusted module fee</p>
      <p className="mt-1">
        <span className="line-through text-amber-700/80 mr-2">
          {currency} {catalog.toLocaleString()}
        </span>
        <span className="font-semibold text-amber-950">
          {currency} {fee.toLocaleString()}
        </span>
      </p>
      {reason ? (
        <p className="mt-1 text-amber-800">
          <span className="font-medium">Reason:</span> {reason}
        </p>
      ) : null}
    </div>
  );
};

export const ModuleFeeAdjustmentReadOnly = ({ module, currency = 'LKR' }) => {
  if (!module) return null;

  const isRepeat = isRepeatFeeModule(module);
  if (isRepeat || module.feeAdjusted) {
    return <ModuleFeeAdjustmentBadge module={module} currency={currency} />;
  }

  const label = formatAdjustedFeeLabel(module, currency);
  if (!label) return null;

  return <p className="text-xs text-gray-600 mt-1">Fee: {label}</p>;
};

export default ModuleFeeAdjustmentBadge;
